import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { AxlModal } from "axl-reactjs-ui";
// Components
import ListJobsUpload from "../../components/UploadComponents/ListJobsUpload";
import ShipmentUploadForm from "../../components/UploadComponents/ShipmentUploadForm";
import Button from "@material-ui/core/Button";
// Styles
import styles, * as E from "./styles";

// @inject('shipmentStore', 'jobStore')
// @observer
class BatchContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showShipmentUploadForm: false,
    };
  }

  componentDidMount() {
    const { jobStore } = this.props;
    jobStore.selectedJob = null;
    jobStore.boundary = null;

    jobStore.getDraftJobs();
    jobStore.getFinalizeJobs();
  }


  openForm = (name) => {
    this.setState({ ["show" + name]: true });
  };

  pingJob = (job) => {
    const { jobStore } = this.props;
    jobStore.getDraftJob(job.id, (respJob) => {
      if (jobStore.isProcessing(respJob.status)) {
        setTimeout(() => this.pingJob(respJob), 1000);
      }
    });
  };

  upload = (acceptFiles) => {
    const { jobStore } = this.props;
    jobStore.upload(acceptFiles[0], (job) => {
      this.pingJob(job);
    });
  };

  closeForm = (name) => {
    this.setState({ ["show" + name]: false });
  };

  render() {
    const { showShipmentUploadForm } = this.state;

    return (
      <E.Contain>
        <E.Inner>
          <E.Head>
            <E.Title>{`Shipment Uploads`}</E.Title>
            <E.GroupControls>
              <Button
                variant="contained"
                color="primary"
                style={{ minWidth: 170 }}
                onClick={() => this.openForm(`ShipmentUploadForm`)}
              >{`Upload Batch`}</Button>
              {showShipmentUploadForm && (
                <AxlModal
                  style={styles.Modal}
                  onClose={() => this.closeForm(`ShipmentUploadForm`)}
                >
                  <ShipmentUploadForm
                    onClose={() => this.closeForm(`ShipmentUploadForm`)}
                  />
                </AxlModal>
              )}
              <Button
                variant="outlined"
                color="primary"
                style={{ minWidth: 170, marginLeft: 10 }}
                onClick={() => this.props.history.push("/batch/new-order")}
              >{`Create Single Shipment`}</Button>
            </E.GroupControls>
          </E.Head>
          <E.Main>
            <E.Section>
              <E.Panel>
                <ListJobsUpload />
              </E.Panel>
            </E.Section>
          </E.Main>
        </E.Inner>
      </E.Contain>
    );
  }
}

export default observer(inject("shipmentStore", "jobStore")(BatchContainer));
